import { format, isValid, parseISO } from "date-fns";
import { useEffect, useState } from "react";

export const removeHtmlTags = (htmlString) => {
  const tempElement = document.createElement("div");
  tempElement.innerHTML = htmlString;
  // Get the text content without HTML tags
  return tempElement.textContent || tempElement.innerText || "";
};

export const useDebounce = (value, delay) => {
  const [dbValue, setDbValue] = useState("");
  useEffect(() => {
    let timeOut = setTimeout(() => {
      setDbValue(value);
    }, delay);

    return () => {
      clearTimeout(timeOut);
    };
  }, [value, delay]);
  return dbValue;
};

export const convertNumberToWords = (number) => {
  if (!number && typeof +number !== Number) return false;
  if (number === 0) return "zero";

  const belowTwenty = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];

  const tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  const aboveThousand = ["", "thousand", "million", "billion"];

  function helper(num) {
    if (num < 20) return belowTwenty[num];
    else if (num < 100)
      return (
        tens[Math.floor(num / 10)] +
        (num % 10 !== 0 ? " " + belowTwenty[num % 10] : "")
      );
    else
      return (
        belowTwenty[Math.floor(num / 100)] +
        " hundred" +
        (num % 100 !== 0 ? " " + helper(num % 100) : "")
      );
  }

  let word = "";
  let unitIndex = 0;

  while (number > 0) {
    const chunk = number % 1000;
    if (chunk !== 0) {
      const chunkWord = helper(chunk);
      word =
        chunkWord +
        (aboveThousand[unitIndex] !== ""
          ? " " + aboveThousand[unitIndex]
          : "") +
        (word ? " " + word : "");
    }
    number = Math.floor(number / 1000);
    unitIndex++;
  }

  return word.trim();
};

export const ucFirst = (s) => {
  if (!s) return "";
  let str = s.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const ucWords = (s) => (s && s.replace(/\w\S*/g, ucFirst)) || "";

export function zodErrorResolver(errorsArray) {
  const result = {};

  errorsArray &&
    errorsArray.forEach((error) => {
      const key = error.path[0];
      result[key] = { message: error.message };
    });

  return result;
}

export function isEmptyObject(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export const formatDateSafely = (date) => {
  const parsedDate = date instanceof Date ? date : parseISO(date);
  return isValid(parsedDate)
    ? format(parsedDate, "yyyy-MM-dd")
    : "Invalid Date";
};

export const stripHtml = (html) => {
  if (!html) return "";

  // Convert <br> tags to newlines
  let text = html.replace(/<br\s*\/?>/gi, "\n");

  // Convert <p> tags to newlines (consider both opening and closing for robustness)
  text = text.replace(/<\s*p[^>]*>/gi, ""); // Opening p
  text = text.replace(/<\s*\/p\s*>/gi, "\n"); // Closing p

  // Convert <div> tags to newlines (consider both opening and closing for robustness)
  text = text.replace(/<\s*div[^>]*>/gi, ""); // Opening div
  text = text.replace(/<\s*\/div\s*>/gi, "\n"); // Closing div

  // Remove all other HTML tags
  const doc = new DOMParser().parseFromString(text, "text/html");
  return doc.body.textContent || "";
};
